import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger, ScrollToPlugin } from "gsap/all";
import LandingHeader from "../common/LandingHeader";
import LandingFooter from "../common/LandingFooter";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import "./about.scss";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const cardContents = [
  {
    id: 1,
    imgSrc: "mission-img01.png",
    subTitle: "The Power of Language AI:",
    title: "Enriching Knowledge",
    subTitle: "The Power of Language AI:",
    para: "JIGYAASU can be utilized to unlock the full potential of a student's learning journey. Our advanced AI is trained on a vast corpus of educational resources, including textbooks and study materials, enabling it to understand context, provide accurate information, and offer valuable insights. Whether you need help with homework, research papers, or exam preparation, JIGYAASU is your ultimate learning companion.",
    btnText: "Learn More"
  },
  {
    id: 2,
    imgSrc: "mission-img02.png",
    subTitle: "Our Commitment:",
    title: "Excellence and Innovation",
    para: "JIGYAASU can be utilized to unlock the full potential of a student's learning journey. Our advanced AI is trained on a vast corpus of educational resources, including textbooks and study materials, enabling it to understand context, provide accurate information, and offer valuable insights.",
    btnText: "Learn More"
  },
  {
    id: 3,
    imgSrc: "mission-img03.png",
    subTitle: "Join the JIGYAASU Community:",
    title: "Enriching Knowledge",
    para: "JIGYAASU can be utilized to unlock the full potential of a student's learning journey. Our advanced AI is trained on a vast corpus of educational resources, including textbooks and study materials, enabling it to understand context, provide accurate information, and offer valuable insights. Whether you need help with homework, research papers, or exam preparation, JIGYAASU is your ultimate learning companion.",
    btnText: "Learn More"
  },
];

const carouselOptions = {
  stagePadding: 10,
  loop: true,
  nav: false,
  dots: false,
  autoplay: true,
  autoplayHoverPause: true,
  autoplayTimeout: 3500,
  autoplaySpeed: 5000,
  slideTransition: "linear",
  responsive: {
    0: {
      items: 1.5,
      margin: 15,
    },
    569: {
      items: 1.8,
      margin: 20,
    },
    1024: {
      items: 3.1,
      margin: 18,
    },
    1451: {
      items: 3.15,
      margin: 25,
    },
    1800: {
      items: 4,
      margin: 20,
    },
    1921: {
      items: 4.5,
      margin: 20,
    },
  },
};

const AboutPage = () => {
  const cardsRef = useRef([]);
  const [activeNav, setActiveNav] = useState(0);

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".stacked-cards",
        pin: true,
        pinSpacing: true,
        markers: false,
        start: "top-=200px top",
        end: "+=1500",
        scrub: 1,
      },
    });

    // Animation for card 1
    tl.addLabel("card1");
    tl.to(cardsRef.current[0], {
      yPercent: 0,
      opacity: 1,
    });

    // Animation for card 2
    tl.from(cardsRef.current[1], {
      yPercent: 0.2,
      opacity: 0,
    });
    tl.addLabel("card2");
    tl.add(() => setActiveNav(tl.scrollTrigger.direction > 0 ? 1 : 0), "-=0.15");
    tl.to(cardsRef.current[0], {
      scale: 0.925,
      yPercent: -2,
      opacity: 1,
    }, "-=0.3");
    tl.to(cardsRef.current[1], {
      yPercent: 0,
      opacity: 1,
    });

    // Animation for card 3
    tl.from(cardsRef.current[2], {
      yPercent: 0.6,
      opacity: 0,
    });
    tl.addLabel("card3");
    tl.add(() => setActiveNav(tl.scrollTrigger.direction > 0 ? 2 : 1), "-=0.15");
    tl.to(cardsRef.current[1], {
      scale: 0.95,
      yPercent: -1.75,
      opacity: 1,
    }, "-=0.3");
    tl.to(cardsRef.current[2], {
      yPercent: 0,
      opacity: 1,
    });

    // Animation for card 4
    // tl.from(cardsRef.current[3], {
    //   yPercent: 0.2,
    //   opacity: 0,
    // });
    // tl.addLabel("card4");
    // tl.add(() => setActiveNav(tl.scrollTrigger.direction > 0 ? 3 : 2), "-=0.15");
    // tl.to(cardsRef.current[2], {
    //   scale: 0.97,
    //   yPercent: -1.85,
    //   opacity: 1,
    // }, "-=0.3");
    // tl.to(cardsRef.current[3], {
    //   yPercent: 0,
    //   opacity: 1,
    // });

    // Additional animations for scaling down previous cards
    tl.to(cardsRef.current[0], {
      scale: 0.925,
      yPercent: -2,
      opacity: 0.9,
    }, "-=0.3");

    tl.to(cardsRef.current[1], {
      scale: 0.95,
      yPercent: -2.2,
      opacity: 1,
    }, "-=0.3");

    tl.to(cardsRef.current[2], {
      scale: 0.98,
      yPercent: -2.25,
      opacity: 1,
    }, "-=0.3");

    return () => {
      tl.kill();
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <div className="landing overflow-hidden">

      <section className="section heroSec pt-4">
        <LandingHeader />

        <div className="container">
          <div className="hero-content">
            <div class="hero-main hero-main--about"><div class="hero-main__content">
              <h1 class="ff3 fw500 main-hero-heading">
                Fueling Curiosity. Empowering Progress. Guiding Learner’s Journey.
              </h1>
              <p class="fz22 sub-title">
                {/* <strong className="fz24">
                
                </strong> */}
                At Jigyaasu.ai, we believe that every student deserves a personal guide on
                their learning journey - one that adapts to their pace, understands their
                strengths, and helps them grow through consistent practice and self-
                reflection.
                That’s why we built Jigyaasu - an AI-enabled SaaS platform for educational
                institutions to empower every student with personalized learning, self-
                assessment, and intelligent code practice, acting as a scalable, always-on
                personal tutor that enhances classroom learning outcomes.
              </p>
              <button class="btn btn-solid btn-solid--dark fw500">Learn About Us</button>
            </div>
              <div class="hero-main__img">
                <img src="./assets/images/landing/about-hero-image.png" alt="hero-image" />
              </div>
            </div>
          </div>
        </div>
      </section>



      <section className="empowerSec">
        <div className="container">
          <div className="empower">
            <div className="text-white bdrs40 empower__block">
              <img src="./assets/images/landing/icon-double-quote.svg" alt="double-quote-image" loading="lazy" />
              <h2 className="ff2 fw700 fz56">
                Empowering Students with AI-Powered Learning
              </h2>
              <p className="fz24 fw400 ff1">
                At JIGYAASU, our vision is to revolutionize the way students learn by harnessing the power of artificial intelligence. We believe that education should be accessible, engaging, and personalized. With JIGYAASU, we aim to empower students to effortlessly find accurate answers to their academic questions and enhance their learning experience.
              </p>

              <button class="btn btn-solid btn-solid--white fw500">Learn More</button>
            </div>
            <div className="empower__img">
              <img src="./assets/images/landing/empowering-about-sub-hero.png" alt="sub-hero-image" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      <section className="mission">
        <div className="container">
          <div className="stacking-card-wrapper">
            <div className="text-white section-heading">
              <h2 className="text-center fz72 fw700 ff3">
                Our Mission
              </h2>
              <p className="text-center fz20">
                Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.
              </p>
            </div>

            <div className="stacked-cards">
              {cardContents.map((card, i) => (
                <div
                  className={`custom-card card${i + 1}`}
                  id={card.id}
                  key={card.id}
                  ref={el => cardsRef.current[i] = el}
                  style={{ zIndex: i + 2 }}
                >
                  <div className="card-inner">
                    <div className="card-inner__img">
                      <img src={`./assets/images/landing/${card.imgSrc}`} alt="" />
                    </div>
                    <div className="ff2 card-inner__content">
                      <h6 className="fz24 fw700 sub-title">{card.subTitle}</h6>
                      <h2 className="fz64 fw700">{card.title}</h2>
                      <p className="ff1 fz22 para-text">{card.para}</p>
                      <button className="btn btn-solid btn-solid--dark">
                        {card.btnText}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

          </div>


        </div>
      </section>

      <section className="teamSec">
        <div className="container">
          <div className="team">
            <h2 className="text-center ff3 fw700 fz72">
              Our Team
            </h2>
            <p className="text-center fz20 fw400 ff1">
              Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.
            </p>
            <OwlCarousel
              className="owl-carousel--horizontal"
              {...carouselOptions}
            >

              <div className="item">
                <div className="bdrs40 text-white team-card team-card--textTop color01">
                  <div className="team-card__text">
                    <h3 className="fz36 fw800 ff2">
                      Clark Kent
                    </h3>
                    <h6 className="fz24 fw500">
                      Founder & CEO
                    </h6>
                  </div>
                  <div className="bdrs40 team-card__img">
                    <img src="./assets/images/landing/team01.png" alt="" />
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="bdrs40 text-white team-card team-card--textBottom color02">
                  <div className="team-card__text">
                    <h3 className="fz36 fw800 ff2">
                      Liza Doolittle
                    </h3>
                    <h6 className="fz24 fw500">
                      Founder & CEO
                    </h6>
                  </div>
                  <div className="bdrs40 team-card__img">
                    <img src="./assets/images/landing/team02.png" alt="" />
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="bdrs40 text-white team-card team-card--textTop color03">
                  <div className="team-card__text">
                    <h3 className="fz36 fw800 ff2">
                      Aileen Gomes
                    </h3>
                    <h6 className="fz24 fw500">
                      Chief of Staff
                    </h6>
                  </div>
                  <div className="bdrs40 team-card__img">
                    <img src="./assets/images/landing/team03.png" alt="" />
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="bdrs40 text-white team-card team-card--textBottom color02">
                  <div className="team-card__text">
                    <h3 className="fz36 fw800 ff2">
                      Clark Kent
                    </h3>
                    <h6 className="fz24 fw500">
                      Founder & CEO
                    </h6>
                  </div>
                  <div className="bdrs40 team-card__img">
                    <img src="./assets/images/landing/team01.png" alt="" />
                  </div>
                </div>
              </div>
            </OwlCarousel>
          </div>
        </div>
      </section>

      <LandingFooter />

    </div>
  );
};

export default AboutPage;
